import { EquipmentMetric } from './systemTypes.models';

const parseSystemTypeToMetric = (
  unit: string,
  metricType: string,
  segment: string,
  metrics: EquipmentMetric[]
) => {
  return (
    metrics
      .filter(
        (m) =>
          m.unit === unit &&
          m.metricType === metricType &&
          m.segment === segment
      )
      .flatMap((m) => m.values)
      .map((value) => value.label) || []
  );
};

export const getSystemMetricsOptions = (metrics: EquipmentMetric[]) => {
  return {
    heatingCapacityOptions: parseSystemTypeToMetric(
      'BTU',
      'CAPACITY',
      'HEATING',
      metrics
    ),
    coolingCapacityOptions: parseSystemTypeToMetric(
      'TON',
      'CAPACITY',
      'COOLING',
      metrics
    ),
    heatingEfficiencyOptions: parseSystemTypeToMetric(
      'AFUE',
      'EFFICIENCY',
      'HEATING',
      metrics
    ),
    coolingEfficiencyOptions: parseSystemTypeToMetric(
      'SEER2',
      'EFFICIENCY',
      'COOLING',
      metrics
    ),
  };
};
